import { PenTool, Sparkles, Component, Gauge } from "lucide-react";
import { SERVICES } from "../../data";
import Reveal from "./Reveal";
import PaymentCTA from "./PaymentCTA";

const ICONS = { PenTool, Sparkles, Component, Gauge };

const Services = () => (
  <section id="services" className="py-24 lg:py-32 bg-[#0b0b0f]" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-blue-400 mb-4">Expertises</p>
        <h2 className="font-display font-bold tracking-tight text-2xl sm:text-4xl lg:text-5xl mb-16">
          Ce que je fais,<br />et que je fais <span className="text-blue-500">bien</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
        {SERVICES.map((service, i) => {
          const Icon = ICONS[service.icon];
          return (
            <Reveal key={service.title} delay={i * 0.1} className={service.span}>
              <div
                className="group h-full rounded-2xl border border-white/10 bg-[#111115] p-6 sm:p-8 lg:p-10 hover:border-blue-500/40 hover:-translate-y-1 transition-all duration-500"
                data-testid={`service-card-${i}`}
              >
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-6 group-hover:bg-blue-500/20 transition-colors duration-500">
                  <Icon size={22} className="text-blue-400" />
                </div>
                <h3 className="font-display font-semibold text-xl sm:text-2xl tracking-tight mb-3">{service.title}</h3>
                <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-6">{service.description}</p>
                <div className="flex flex-wrap gap-2">
                  {service.tags.map((tag) => (
                    <span key={tag} className="px-3 py-1 rounded-full text-xs font-mono text-zinc-500 border border-white/10">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <PaymentCTA />
    </div>
  </section>
);

export default Services;
